import React from 'react';

import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import Search from './Search';

const styles = (theme) => ({
  appBar: {
    zIndex: 1201,
    backgroundColor: '#607d8b',
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
  toolbar: {
    justifyContent: 'space-between',
  },
  menuButton: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },  
});


function getSiteInfo() {
  const host = window.location.host.toLowerCase();

  if (host.includes('house')) {
    return {
      title: 'IntraHouse',
      url: 'https://intrahouse.ru/',
    };
  }

  if (host.includes('opc')) {
    return {
      title: 'IntraOPC',
      url: 'https://intraopc.com/',
    };
  }

  return {
    title: 'IntraSCADA',
    url: 'https://intrascada.ru/',
  };
}

// Обработчик клика — открывает сайт в новой вкладке
function handleTitleClick() {
  const { url } = getSiteInfo();
  window.open(url, '_blank', 'noopener');
}

function MainAppBar({ history, classes, lang, handleDrawerToggle, handleChangeLang }) {
  const { title } = getSiteInfo();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>

        {/* Клик по заголовку открывает сайт в новой вкладке */}
        <Typography
          style={{ cursor: 'pointer' }}
          variant="h6"
          noWrap
          onClick={handleTitleClick}
        >
          {title}
        </Typography>

        <Search.SectionMobile
          history={history}
          lang={lang}
          onChangeLang={handleChangeLang}
        />
        <Search.SectionDesktop
          history={history}
          lang={lang}
          onChangeLang={handleChangeLang}
        />
      </Toolbar>
    </AppBar>
  );
}

export default withStyles(styles)(MainAppBar);